<div  role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div *ngIf="UploadProgress > 0" class="progressDiv">
            <span>Uploading File : {{UploadProgress}} % Completed</span>
            <mat-progress-bar  color="primary" class="fileUploader" mode="determinate" value="{{UploadProgress}}"></mat-progress-bar>
        </div>
        <ngx-dropzone (change)="uploadFiles($event)">
            <ngx-dropzone-label>Upload New Document</ngx-dropzone-label>
        </ngx-dropzone>
        <div class="documentDiv">
            <div *ngFor="let file of selectedFile; let i = index ">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field>
                            <input matInput name="fileName" [(ngModel)]="selectedFile[i].name.name" placeholder="Name of the File"> 
                        </mat-form-field>
                    </div>
                    <div class="col-md-5">
                        <mat-form-field>
                            <mat-select name="fileType" [(ngModel)]="selectedFile[i]['type']" placeholder="Document Type">
                                <mat-option *ngFor="let documentType of documentTypeData;" value='{{documentType.id}}'>{{ documentType.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-1">
                        <a style="margin-top: 20px; display: block;" (click)="deleteSelectedFile(file.index)"><i class="icon-trash"></i></a>
                    </div>
                </div> 
            </div>
        </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="saveDocument()" [disabled]="selectedFile == null || selectedFile.length < 1">Upload Documents</button>
            <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
        </div>
    </div>
</div>